export const appearances: readonly ['circle', 'square', 'hexagon'] = [
	'circle',
	'square',
	'hexagon',
] as const;
